export class BaseDto {
    public Identifier: string;
    public Name: string;
}


// WEBPACK FOOTER //
// C:/git/flowdesigner/src/dto/BaseDto.ts